import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import React from "react";

const InlineLoadError = ({ i18n, onRetry }) => (
    <SovosBox role="alert" sx={{ alignItems: "center", display: "flex", gap: 1, mb: 2 }}>
        <SovosTypography color="error" variant="caption">
            {i18n`Unable to load mapping configuration.`}
        </SovosTypography>
        <SovosButton onClick={onRetry} size="small" variant="text">
            {i18n`Retry`}
        </SovosButton>
    </SovosBox>
);

export default InlineLoadError;
